import { httpClient } from '../httpClient';
import {
  IChatMessage,
  CreateChatMessageRequest,
  GetChatMessagesRequest,
  ChatContextType
} from '@packages/global';

const BASE_URL = '/user/chat-messages';

export const chatMessageApi = {
  /**
   * 获取聊天消息列表
   */
  async list(params: GetChatMessagesRequest): Promise<IChatMessage[]> {
    const queryParams = new URLSearchParams({
      projectId: params.projectId,
      contextType: params.contextType,
    });
    if (params.contextId) {
      queryParams.append('contextId', params.contextId);
    }
    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }
    return httpClient.get<IChatMessage[]>(`${BASE_URL}?${queryParams.toString()}`);
  },

  /**
   * 创建聊天消息
   */
  async create(data: CreateChatMessageRequest): Promise<IChatMessage> {
    return httpClient.post<IChatMessage>(BASE_URL, data);
  },

  /**
   * 删除单条消息
   */
  async delete(id: string): Promise<void> {
    return httpClient.delete<void>(`${BASE_URL}/${id}`);
  },

  /**
   * 清空聊天记录
   */
  async clear(projectId: string, contextType: ChatContextType, contextId?: string): Promise<void> {
    const queryParams = new URLSearchParams({
      projectId,
      contextType,
    });
    if (contextId) {
      queryParams.append('contextId', contextId);
    }
    return httpClient.delete<void>(`${BASE_URL}?${queryParams.toString()}`);
  },

  /**
   * 标记操作卡片已应用
   */
  async markActionApplied(messageId: string, actionIndex: number): Promise<void> {
    return httpClient.patch<void>(`${BASE_URL}/${messageId}/apply-action`, { actionIndex });
  },
};
